// removed by extract-text-webpack-plugin
module.exports = {"icon":"_3l3B660osTvF3MjrwtLzs7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/agendaItemSummary/styles.css
// module id = 1106
// module chunks = 0